import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        videoPath: "",
        videoPaths: "",
        listShow: "", //兄弟组件互相影响时使用
        jieId: "",
        IsTip: false,
        LiveLesson: null,
        IsStatus: 0,
    },
    mutations: {
        increment(state, videoObj) {
            state.videoPath = videoObj;
        },
        videoPathChange(state, video) {
            if (video.file_path) {
                state.videoPath.src(video.file_path);
            } else {
                state.videoPaths = true;
                state.IsTip = true;
            }

            //state.videoPath.play();
            //state.jieId = video.id;//点击节时 节id赋值给state.jieId
        },
        jieChoosed(state, video) {
            state.jieId = video.id; //点击节时 节id赋值给state.jieId
        },
        listShowChange(state, id) {
            state.listShow = id; //点击章时 章id赋值给state.listShow
        },
        //控制视频封面  收费信息或cover
        videoPathsChange(state, data) {
            state.videoPaths = data;
        },
        //给直播添加默认值
        UpdateLiveLesson(state, obj) {
            state.LiveLesson = obj;
        },
        //给直播添加默认值
        UpdateStatus(state, obj) {
            state.IsStatus = obj;
        }
    },
    actions: {
        UpdateLiveLesson: ({ commit }, obj) => {
            commit('UpdateLiveLesson', obj);
        },
        UpdateStatus: ({ commit }, obj) => {
            commit('UpdateStatus', obj);
        }
    },
    getters: {
        GetLiveLesson: (state) => {
            return state.LiveLesson;
        },
        GetStatus: (state) => {
            return state.IsStatus;
        }
    }
});
